/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one character type`)
};

const es_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona al menos un tipo de carácter`)
};

const de_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie mindestens einen Zeichentyp aus`)
};

const nl_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer minimaal één tekentype`)
};

const fr_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez au moins un type de caractère`)
};

const it_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona almeno un tipo di carattere`)
};

const pt_br2_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione pelo menos um tipo de caractere`)
};

const pt_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione pelo menos um tipo de carácter`)
};

const ja_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低1つ以上の文字タイプを選択`)
};

const zh_pw_select_charset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请至少选择一种字符类型`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_select_charset = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_select_charset(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_select_charset", locale)
	if (locale === "en") return en_pw_select_charset(inputs)
	if (locale === "es") return es_pw_select_charset(inputs)
	if (locale === "de") return de_pw_select_charset(inputs)
	if (locale === "nl") return nl_pw_select_charset(inputs)
	if (locale === "fr") return fr_pw_select_charset(inputs)
	if (locale === "it") return it_pw_select_charset(inputs)
	if (locale === "pt-BR") return pt_br2_pw_select_charset(inputs)
	if (locale === "pt") return pt_pw_select_charset(inputs)
	if (locale === "ja") return ja_pw_select_charset(inputs)
	return zh_pw_select_charset(inputs)
};